(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_statusDeleteController',Qsched_statusDeleteController);

    Qsched_statusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Qsched_status'];

    function Qsched_statusDeleteController($uibModalInstance, entity, Qsched_status) {
        var vm = this;

        vm.qsched_status = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Qsched_status.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
